import React from 'react'

import './chat-mockup.css'

// Maqueta de una conversación de WhatsApp con Secretario. Es ilustrativa.
const ChatMockup = ({ messages }) => (
  <div className="chat" role="img" aria-label="Ejemplo de conversación con Secretario en WhatsApp">
    <div className="chat__head">
      <img src="/logo-variant.png" alt="" className="chat__avatar" />
      <div>
        <strong>Secretario</strong>
        <span>en línea</span>
      </div>
    </div>
    <div className="chat__body">
      {messages.map((m, i) => (
        <div key={i} className={`chat__msg chat__msg--${m.from}`}>
          {m.text}
          <span className="chat__time">{m.time}</span>
        </div>
      ))}
    </div>
  </div>
)

export default ChatMockup
